// Action Types
export const ACTIVE_TAB_ACTIONS = {
  SET_ACTIVE_TAB_CHAT_OR_CONVERSION: "SET_ACTIVE_TAB_CHAT_OR_CONVERSION",
};

// Initial State - sidebar is the default active tab
const initialState = {
  activeTab: "sidebar"
};

// Active Tab Reducer
const ActiveTabChatOrConversionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_TAB_ACTIONS.SET_ACTIVE_TAB_CHAT_OR_CONVERSION:
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};

// Action Creators
export const setActiveTabChatOrConversion = (tab) => ({
  type: ACTIVE_TAB_ACTIONS.SET_ACTIVE_TAB_CHAT_OR_CONVERSION,
  payload: tab
});

export default ActiveTabChatOrConversionReducer;
